import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageIn"><Path d="M20.5 11.5V3.5H3.5V20.5H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 3.5V9.5H15.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 20.5V18.5C21.5 17.3954 20.6046 16.5 19.5 16.5H15M16.5 14.5L14.5 16.5L16.5 18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageIn;
